import React from 'react';
import { Home, About, Jobs, Education, Skills, Contact } from './';
import MountainBreak from './MountainBreak';

const Main = () => (
	<main>
		<Home />
		<About />
		<Skills />
		<MountainBreak />
		<Jobs />
		<Education />
		<Contact />
	</main>
);

export default Main;